import { isAndroid as c } from "./index725.js";
import { EVENT_CODE as o } from "./index590.js";
const a = (e, t, { checkForDefaultPrevented: r = !0 } = {}) => (n) => {
  const i = e?.(n);
  if (r === !1 || !i)
    return t?.(n);
}, f = (e) => {
  if (e.code && e.code !== "Unidentified") return e.code;
  const t = d(e);
  if (t) {
    if (Object.values(o).includes(t)) return t;
    switch (t) {
      case " ":
        return o.space;
      default:
        return "";
    }
  }
  return "";
}, d = (e) => {
  let t = e.key && e.key !== "Unidentified" ? e.key : "";
  if (!t && e.type === "keyup" && c()) {
    const r = e.target;
    t = r.value.charAt(r.selectionStart - 1);
  }
  return t;
};
export {
  a as composeEventHandlers,
  f as getEventCode,
  d as getEventKey
};
